module.exports = __webpack_public_path__ + "img/permission.7f41d4b3.png";